import { triggerLoanStatementCreation } from 'APIs/loan.statement/loanstatement';
import Message from 'Components/Message';
import Modal from 'Components/Modal/Modal';
import { Label } from 'Constants/styles';
import { FormEvent, MouseEvent, ReactElement, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import getErrorMessage from 'utils/getErrorMessage';

import { FormField, FormRow, TextInput } from './styles';

type Props = {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
};

const TriggerLoanStatementCreation = ({ showModal, setShowModal }: Props): ReactElement => {
  const { apiAprilBaseUri } = useSelector((state: ReduxStateType) => ({
    apiAprilBaseUri: state.apiAprilBaseUri,
  }));

  const [loanId, setLoanId] = useState<string>('');
  const [modalIsLoading, setModalIsLoading] = useState<boolean>(false);
  const [modalErrorMsg, setModalErrorMsg] = useState<string>('');

  const handleSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setModalErrorMsg('');

      try {
        if (loanId) {
          const confirmed = window.confirm(`Are you sure you want to create loan statement for loan ID ${loanId}?`);
          if (!confirmed) {
            return;
          }
          setModalIsLoading(true);
          const payload = {
            TriggerLoanStatementCreation: {},
          };
          await triggerLoanStatementCreation(apiAprilBaseUri, loanId, payload);
          setLoanId('');
          setShowModal(false);
        }
      } catch (e) {
        setModalErrorMsg(getErrorMessage(e));
      } finally {
        setModalIsLoading(false);
      }
    },
    [apiAprilBaseUri, loanId, setShowModal],
  );

  const handleCloseModalMsg = (e: MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    setModalErrorMsg('');
  };

  const handleCancel = (e: MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    setShowModal(false);
    setModalErrorMsg('');
    setLoanId('');
  };

  return (
    <>
      {showModal && (
        <Modal
          title="Loan Statement Creation"
          cancelBtnText="Cancel"
          confirmBtnText="Create"
          handleCancel={handleCancel}
          handleSubmit={handleSubmit}
          disableConfirmBtn={modalIsLoading}
          isLoading={modalIsLoading}
          testId={'loan-statement-creation-trigger-modal'}
        >
          {modalErrorMsg.length > 0 && (
            <Message
              className="mt-2 mb-0"
              success={false}
              description={modalErrorMsg}
              handleClose={handleCloseModalMsg}
            />
          )}
          <div className="form">
            <FormRow>
              <Label>Loan ID</Label>
              <FormField>
                <TextInput
                  type="text"
                  name="loanId"
                  placeholder="Eg. loan_xxxxxxxxxxxxxxxx"
                  value={loanId}
                  required
                  onChange={(e) => setLoanId(e.target.value)}
                  data-testid="trigger-loan-statement-creation-modal-loanid-input"
                />
              </FormField>
            </FormRow>
          </div>
        </Modal>
      )}
    </>
  );
};

export default TriggerLoanStatementCreation;
